import withJsonLd from './with-json-ld';
export default withJsonLd;